import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../../common/input';
import CurrencyInput from '../../../../common/currencyInput';
import OptionInput from '../../../../common/optionInput';
import CancelButtonLink from '../../../../common/buttons/cancelButtonLink';
import * as shapes from '../shapes';
import discountTypes from '../discountTypes';
import discountAssignment from '../discountAssignment';


const Form = ({ baseUrl, canModify, discountType, edit, handleSubmit, pristine, submitting, valid, onDelete }) => {
  const discountTypeFixed = discountType === discountTypes.fixed;
  const disableSaveButton = pristine || !valid || !canModify;

  return (
    <div className="c-wrapper">
      <div className="u-max-width-710 u-margin-auto">
        <div className="c-inner-wrapper u-pt">
          <h2 className="c-heading c-heading--lightgrey u-mb">Discounts</h2>
          <form onSubmit={handleSubmit}>
            <fieldset disabled={submitting}>
              <div className="u-ph">
                <div className="layout">
                  <div className="layout__item u-1/2-large-and-up">
                    <span className="c-label-new">Name</span>
                    <Input
                      className="c-input"
                      disabled={!canModify}
                      name="name"
                      type="text"
                      placeholder="Discount name"
                    />
                  </div>
                  <div className="layout__item u-1/2-large-and-up">
                    <span className="c-label-new">Value</span>
                    <Input
                      className="c-input c-input--prepend"
                      disabled={!canModify}
                      name="value"
                      type="number"
                      step="any"
                      placeholder="Value"
                      prefix="%"
                      parse={value => parseFloat(value)}
                      display-if={!discountTypeFixed}
                    />
                    <CurrencyInput
                      className="c-input c-input--prepend"
                      disabled={!canModify}
                      name="value"
                      type="number"
                      placeholder="Value"
                      parse={value => parseInt(value, 10)}
                      display-if={discountTypeFixed}
                    />
                  </div>
                  <div className="layout__item">
                    <span className="c-label-new">Type</span>
                    <div className="layout layout--small layout--auto">
                      <div className="layout__item">
                        <OptionInput
                          disabled={!canModify}
                          name="type"
                          value={discountTypes.percentage}
                        >
                          Percentage
                        </OptionInput>
                      </div>
                      <div className="layout__item">
                        <OptionInput
                          disabled={!canModify}
                          name="type"
                          value={discountTypes.fixed}
                        >
                          Fixed
                        </OptionInput>
                      </div>
                    </div>
                    <span className="c-label-new">Assignment</span>
                    <div className="layout layout--small layout--auto">
                      <div className="layout__item">
                        <OptionInput
                          disabled={!canModify}
                          name="assignment"
                          value={discountAssignment.all}
                        >
                          Services &amp; Products
                        </OptionInput>
                      </div>
                      <div className="layout__item">
                        <OptionInput
                          disabled={!canModify}
                          name="assignment"
                          value={discountAssignment.products}
                        >
                          Products Only
                        </OptionInput>
                      </div>
                      <div className="layout__item">
                        <OptionInput
                          disabled={!canModify}
                          name="assignment"
                          value={discountAssignment.services}
                        >
                          Services Only
                        </OptionInput>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-separator u-mv" />
              <div className="u-text-right">
                <button
                  disabled={!canModify}
                  type="button"
                  className="c-btn c-btn--red u-width-120 u-mr- u-float-left"
                  onClick={onDelete}
                  display-if={edit}
                >
                  <span className="c-btn__text">Delete</span>
                </button>
                <CancelButtonLink link={baseUrl} content="Cancel" />
                <button
                  type="submit"
                  className="c-btn u-width-120"
                  disabled={disableSaveButton}
                >
                  <span className="c-btn__text">Save</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};
Form.propTypes = {
  canModify: PropTypes.bool,
  handleSubmit: shapes.handler,
  onDelete: shapes.handler,
  edit: shapes.edit,
  pristine: shapes.pristine,
  submitting: shapes.submitting,
  valid: shapes.valid,
  baseUrl: shapes.url,
  discountType: shapes.string,
};
Form.defaultProps = {
  canModify: false,
  handleSubmit: () => null,
  onDelete: () => null,
  edit: false,
  pristine: false,
  submitting: false,
  valid: false,
  baseUrl: '/settings/discounts',
  discountType: '',
};

export default Form;
